import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { Subscription, Observable, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import {
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface,
  SwiperNavigationInterface
} from 'ngx-swiper-wrapper';

@Component({
  selector: 'fcp-news-carousel',
  templateUrl: './news-carousel.component.html',
  styleUrls: ['./news-carousel.component.scss']
})
export class NewsCarouselComponent implements OnInit, OnDestroy {
  @Input() public data: any;

  public index;
  public news = [];
  public build;

  public resizeObservable$: Observable<Event>;
  public resizeSubscription$: Subscription;

  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true,
    hideOnClick: false
  };

  private navigation: SwiperNavigationInterface = {
    nextEl: '.swiper-nav-next',
    prevEl: '.swiper-nav-prev',
    hideOnClick: false,
    disabledClass: 'string',
    hiddenClass: 'string'
  };

  public config: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: this.navigation,
    pagination: this.pagination
  };

  constructor() {}

  ngOnInit() {
    this.checkWidth();
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$
      .pipe(debounceTime(300))
      .subscribe(() => {
        this.build = false;
        this.checkWidth();
      });
  }

  checkWidth() {
    this.build = true;
    if (window.innerWidth > 1150) {
      this.config.slidesPerView = 3;
      return;
    } else if (window.innerWidth > 580) {
      this.config.slidesPerView = 2;
      return;
    }
    this.config.slidesPerView = 1;
  }

  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe();
  }
}
